import React, { useState } from 'react';
import './FAQSection.css'; // Create this CSS file next

const faqs = [
  {
    question: 'What services do we offer?',
    answer: 'We offer website design & development, Facebook/Google ads setup and management, Pixel and tracking setup, and SEO and digital consulting.',
  },
  {
    question: 'Will my website really be custom?',
    answer: 'Yes, we create custom-designed websites tailored to your specific business needs and branding.',
  },
   {
    question: 'How do I qualify as your client?',
    answer: 'Generally, we work with businesses looking to establish or enhance their online presence. Contact us to discuss your specific project and see if we are a good fit.',
  },
    {
    question: 'New website bring me more customers?',
    answer: 'A professionally designed and optimized website can significantly improve your online visibility and user experience, which can lead to attracting more potential customers.',
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section section" id="faq">
      <div className="container">
        <h2>FAQ</h2>
        <p className="section-subtitle">If you have any other questions, don't hesitate to message us using our <a href="/contact">contact form</a>.</p>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <div className="faq-question" onClick={() => handleToggle(index)}>
                {faq.question}
                <span className="faq-toggle-icon">{openIndex === index ? '-' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection; 